import { GraviButton, Horizontal, MaterialIcon, Texto, Vertical } from '@gravitate-js/excalibrr'

import type { ActivityContentProps } from '../../types/activity'

/**
 * A reusable component for displaying different types of activity content
 */
export function ActivityContent({ type, extraData, costRevenue }: ActivityContentProps) {
  switch (type) {
    case 'comment':
      return (
        <Vertical
          border='all'
          borderRadius='6px'
          className='px-3 py-2'
          style={{ overflow: 'visible' }}
          flex='0'
          bg='default'
        >
          <Texto>{extraData?.comment}</Texto>
        </Vertical>
      )
    case 'rebill_approved':
      return (
        <Vertical border='all' borderRadius='6px' className='px-3 py-1'>
          <Horizontal gap={12} verticalCenter>
            <Texto category='h3' appearance='success' weight='600'>
              <MaterialIcon className='pt-1' icon='check_circle' />
            </Texto>
            <Vertical verticalCenter>
              <Texto weight='600'>Credit / Rebill Approved</Texto>
            </Vertical>
          </Horizontal>
        </Vertical>
      )
    case 'ready_for_cr_approval':
      return (
        <Vertical border='all' borderRadius='6px' className='px-3 py-1'>
          <Horizontal gap={12} verticalCenter>
            <Texto category='h3' appearance='warning' weight='600'>
              <MaterialIcon className='pt-2' icon='currency_exchange' />
            </Texto>
            <Vertical verticalCenter>
              <Texto weight='600'>Triggered Credit / Rebill</Texto>
            </Vertical>
          </Horizontal>
        </Vertical>
      )
    case 'placed_on_hold':
      return (
        <Vertical style={{ overflow: 'visible' }} flex='0' border='all' borderRadius='6px' className='p-3'>
          <Horizontal style={{ overflow: 'visible' }} flex='0' gap={16} verticalCenter>
            <Texto category='h1' appearance='warning' weight='600'>
              <MaterialIcon style={{ verticalAlign: 'middle' }} icon='pause_presentation' size={24} />
            </Texto>
            <Vertical style={{ overflow: 'visible' }} flex='0' alignItems='flex-start' gap={4}>
              <Texto weight='600' style={{ whiteSpace: 'nowrap' }}>
                Customer Placed On Hold
              </Texto>
              <Texto appearance='hint'>{extraData?.counterpart}</Texto>
              <Horizontal>
                <GraviButton
                  appearance='link'
                  style={{
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    color: 'var(--theme-color-2)',
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    window.open(`/freight/${costRevenue === 'Cost' ? 'carrier' : 'ratebooks'}`, '_blank')
                  }}
                >
                  View Ratebook →
                </GraviButton>
              </Horizontal>
            </Vertical>
          </Horizontal>
        </Vertical>
      )
    default:
      return null
  }
}
